import { styled } from 'stitches.config'
import { Icon } from 'components/Icon'

export const BreadCrumbsRoot = styled('div', {
    color: '$tertiary-1000',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
})

export const BreadCrumbsContainer = styled('div', {
    display: 'flex',
    alignItems: 'center',
})

export const Arrow = styled(Icon, {
    margin: '0px 4px 0px',
    '@bp2': {
        margin: '0px 4px 4px'
    }
})